export default "__VITE_ASSET__e8F5iMFA__"